(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory('apiErrorHandlerService', apiErrorHandlerService);

  /** @ngInject */
  function apiErrorHandlerService(
    $log,
    errorActions,
    layoutActions,
    $translate,
    $state,
    sessionData,
    dispatcher,
    ActionTypesEnum,
    $window,
    checkAccessRefreshTokenValidity
  ) {
    function apiErrorCallback(data, header, status, apiPromise) {
      var payload;

      // Handle case when data is null or undefined
      if (!data) {
        $log.error('The "data" object is null or undefined.');
        layoutActions.hideLoader();
        payload = {
          errorPageMsg:
            $translate.instant('DEFAULT_ERROR_NAME') +
            '. ' +
            $translate.instant('DEFAULT_ERROR_DESCRIPTION')
        };
        errorActions.showErrorPage(payload);
        apiPromise.reject('An unknown error occurred.');
        return;
      }

      // Handle case when data.message is undefined
      var errorMessage = data.message || $translate.instant('DEFAULT_ERROR_DESCRIPTION');

      $log.error('MESSAGE: ' + errorMessage + ' | ' + 'HEADER: ' + header);

      layoutActions.hideLoader();
      switch (status) {
        case 400:
          if (header === 'onlyMsg') {
            dispatcher.dispatch({
              type: ActionTypesEnum.SHOW_TOASTER_MSG,
              payload: {
                type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
                message: $translate.instant(errorMessage)
              }
            });
            break;
          }
          payload = {
            errorPageMsg: errorMessage
          };
          errorActions.showErrorPageReturnToDashboard(payload);
          break;
        case 401:
          checkAccessRefreshTokenValidity.refreshToken();
          break;
        case 403:
          if (errorMessage === 'Access is denied') {
            sessionData.clearAll();
            $state.go('login');
          } else {
            payload = {
              errorDescription: {
                error: header,
                message: $translate.instant(errorMessage)
              }
            };
            errorActions.showErrorMsg(payload);
            $window.scrollTo(0, 0);
          }
          break;
        case 404:
          payload = {
            errorPageMsg: $translate.instant('MISSING_PAGE')
          };
          errorActions.showErrorPage(payload);
          break;
        case 409:
          payload = {
            errorDescription: {
              error: header,
              message: $translate.instant(errorMessage)
            }
          };
          errorActions.showErrorMsg(payload);
          break;
        case 503:
          payload = {
            errorPageMsg:
              $translate.instant('DEFAULT_ERROR_NAME') +
              '. ' +
              $translate.instant('DEFAULT_ERROR_DESCRIPTION')
          };
          errorActions.showErrorPage(payload);
          break;
        case 500:
          payload = {
            errorPageMsg:
              $translate.instant('DEFAULT_ERROR_NAME') +
              '. ' +
              $translate.instant('DEFAULT_ERROR_DESCRIPTION')
          };
          errorActions.showErrorPage(payload);
          break;
        default:
          payload = {
            errorPageMsg:
              $translate.instant('DEFAULT_ERROR_NAME') +
              '. ' +
              $translate.instant('DEFAULT_ERROR_DESCRIPTION')
          };
          errorActions.showErrorPage(payload);
          apiPromise.reject(errorMessage);
      }
    }

    return apiErrorCallback;
  }
})();
